import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="w-full px-4 py-16 max-w-5xl mx-auto" data-id="element-149">
      <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full md:w-2/5" data-id="element-151">
          <div className="aspect-square bg-cream-dark rounded-2xl border-2 border-brown/20 flex items-center justify-center overflow-hidden shadow-sm" data-id="element-152">
            <img src="https://cdn.magicpatterns.com/uploads/nYsqXoHLnkrhpi81BqPfYf/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm – Verpackung mit natürlichen Zutaten" className="w-full h-full object-cover rounded-2xl" data-id="element-153" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full md:w-3/5" data-id="element-154">
          <h3 className="font-handwriting text-3xl md:text-4xl text-forest font-bold mb-6" data-id="element-155">
            Was ich bestellt habe
          </h3>
          <div className="font-serif text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-156">
            <p data-id="element-157">
              Ich habe mich für das Magen-Darm-Topping von Hunderunde
              entschieden, weil es rein pflanzlich ist und keine künstlichen
              Zusätze enthält. Nach all den teuren Probiotika, die Bruno nicht
              mochte, wollte ich etwas Natürliches, das ich einfach übers Futter
              streuen kann.
            </p>
            <p data-id="element-158">
              Die <strong data-id="element-159">Kombination aus Präbiotika und Ballaststoffen</strong>{' '}
              klang genau richtig für Brunos empfindlichen Magen — und die
              vielen positiven Bewertungen haben mir den letzten Anstoß gegeben.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}